import { isNil } from 'ramda'

const baseUrlRegex = new RegExp(/.+ids\/(\d+)(?:-(\d+)-(\d+)|)\//)
const sizeRegex = new RegExp(/-(\d+)-(\d+)/)

export type GetImageUrlSizeProps = {
  imageUrl: string | undefined
  width: number
  height: number
  highDensityFactor: number
}

export function getImageUrlSize({
  imageUrl,
  width,
  height,
  highDensityFactor,
}: GetImageUrlSizeProps) {
  if (!imageUrl || !width || !height) return undefined

  const widthCalc = Number.isNaN(width) ? 'auto' : width * highDensityFactor
  const heightCalc = Number.isNaN(height) ? 'auto' : height * highDensityFactor
  const resizedImageUrl = imageUrl.slice(0, -1)

  return `${resizedImageUrl}-${widthCalc}-${heightCalc}`
}

export function cleanImageUrl(imageUrl: string | undefined) {
  if (!imageUrl) {
    return undefined
  }

  let resizedImageUrl = imageUrl
  const result = baseUrlRegex.exec(imageUrl)

  if (result && result.length > 0) {
    if (result.length === 4 && !isNil(result[2]) && !isNil(result[3])) {
      resizedImageUrl = result[0].replace(sizeRegex, '')
    } else {
      resizedImageUrl = result[0]
    }

    return resizedImageUrl
  }

  return undefined
}

export function replaceHttpToRelativeProtocol(url: string | undefined) {
  if (!url) {
    return undefined
  }

  return url.replace(/https:\/\/|http:\/\//, '//')
}
